// Offline phrasebook translations.
//
// Pre-translated common phrases for the top travel languages, so the
// Phrasebook truly works offline from the very first tap (not just after
// the user has manually translated each one online).
//
// Key format: `${normalizedSourceText}` where normalization = lowercase + trim.
// Translations live under each target language's section.
//
// Coverage: ~30 phrases × 7 target languages = ~210 entries.
// All English → X (because the Phrasebook UI sends English phrases).
//
// Each value: { translation, romanized? } — `romanized` is a Latin-alphabet
// hint for non-Latin scripts (Japanese/Mandarin) so the user can also
// pronounce it themselves.

const OFFLINE = {
  Spanish: {
    "hello!": { translation: "¡Hola!" },
    "thank you so much.": { translation: "Muchas gracias." },
    "goodbye, have a nice day.": { translation: "Adiós, que tengas un buen día." },
    "sorry, i don't speak the language very well.": { translation: "Lo siento, no hablo muy bien el idioma." },
    "do you speak english?": { translation: "¿Habla usted inglés?" },
    "a table for two, please.": { translation: "Una mesa para dos, por favor." },
    "could i see the menu?": { translation: "¿Me podría traer la carta?" },
    "what do you recommend?": { translation: "¿Qué me recomienda?" },
    "i'll have this one, please.": { translation: "Quiero este, por favor." },
    "is this spicy?": { translation: "¿Esto pica?" },
    "i'm allergic to nuts.": { translation: "Soy alérgico a los frutos secos." },
    "the check, please.": { translation: "La cuenta, por favor." },
    "where is the restroom?": { translation: "¿Dónde está el baño?" },
    "can i have water, no ice?": { translation: "¿Me trae agua sin hielo, por favor?" },
    "delicious, thank you!": { translation: "¡Delicioso, gracias!" },
    "how much does this cost?": { translation: "¿Cuánto cuesta esto?" },
    "do you accept credit card?": { translation: "¿Aceptan tarjeta de crédito?" },
    "is there a discount?": { translation: "¿Hay descuento?" },
    "do you have this in a smaller size?": { translation: "¿Tiene esto en una talla más pequeña?" },
    "can i try it on?": { translation: "¿Me lo puedo probar?" },
    "i'll take it.": { translation: "Me lo llevo." },
    "just looking, thanks.": { translation: "Solo estoy mirando, gracias." },
    "where is the nearest train station?": { translation: "¿Dónde está la estación de tren más cercana?" },
    "how do i get to this address?": { translation: "¿Cómo llego a esta dirección?" },
    "is it far from here?": { translation: "¿Está lejos de aquí?" },
    "can you show me on the map?": { translation: "¿Me lo puede mostrar en el mapa?" },
    "which way to the beach?": { translation: "¿Por dónde se va a la playa?" },
    "is this the right bus?": { translation: "¿Es este el autobús correcto?" },
    "i need help, please.": { translation: "Necesito ayuda, por favor." },
    "call the police.": { translation: "Llame a la policía." },
    "i lost my passport.": { translation: "Perdí mi pasaporte." },
    "i need a doctor.": { translation: "Necesito un médico." },
    "where is the pharmacy?": { translation: "¿Dónde está la farmacia?" },
    "i don't feel well.": { translation: "No me siento bien." },
  },
  French: {
    "hello!": { translation: "Bonjour !" },
    "thank you so much.": { translation: "Merci beaucoup." },
    "goodbye, have a nice day.": { translation: "Au revoir, bonne journée." },
    "sorry, i don't speak the language very well.": { translation: "Désolé, je ne parle pas très bien la langue." },
    "do you speak english?": { translation: "Parlez-vous anglais ?" },
    "a table for two, please.": { translation: "Une table pour deux, s'il vous plaît." },
    "could i see the menu?": { translation: "Pourrais-je voir la carte ?" },
    "what do you recommend?": { translation: "Que recommandez-vous ?" },
    "i'll have this one, please.": { translation: "Je prendrai celui-ci, s'il vous plaît." },
    "is this spicy?": { translation: "C'est épicé ?" },
    "i'm allergic to nuts.": { translation: "Je suis allergique aux fruits à coque." },
    "the check, please.": { translation: "L'addition, s'il vous plaît." },
    "where is the restroom?": { translation: "Où sont les toilettes ?" },
    "can i have water, no ice?": { translation: "Puis-je avoir de l'eau, sans glaçons ?" },
    "delicious, thank you!": { translation: "Délicieux, merci !" },
    "how much does this cost?": { translation: "Combien ça coûte ?" },
    "do you accept credit card?": { translation: "Acceptez-vous la carte de crédit ?" },
    "is there a discount?": { translation: "Y a-t-il une remise ?" },
    "do you have this in a smaller size?": { translation: "Avez-vous ceci dans une taille plus petite ?" },
    "can i try it on?": { translation: "Je peux l'essayer ?" },
    "i'll take it.": { translation: "Je le prends." },
    "just looking, thanks.": { translation: "Je regarde juste, merci." },
    "where is the nearest train station?": { translation: "Où est la gare la plus proche ?" },
    "how do i get to this address?": { translation: "Comment vais-je à cette adresse ?" },
    "is it far from here?": { translation: "C'est loin d'ici ?" },
    "can you show me on the map?": { translation: "Pouvez-vous me montrer sur la carte ?" },
    "which way to the beach?": { translation: "Par où aller à la plage ?" },
    "is this the right bus?": { translation: "Est-ce le bon bus ?" },
    "i need help, please.": { translation: "J'ai besoin d'aide, s'il vous plaît." },
    "call the police.": { translation: "Appelez la police." },
    "i lost my passport.": { translation: "J'ai perdu mon passeport." },
    "i need a doctor.": { translation: "J'ai besoin d'un médecin." },
    "where is the pharmacy?": { translation: "Où est la pharmacie ?" },
    "i don't feel well.": { translation: "Je ne me sens pas bien." },
  },
  Italian: {
    "hello!": { translation: "Ciao!" },
    "thank you so much.": { translation: "Grazie mille." },
    "goodbye, have a nice day.": { translation: "Arrivederci, buona giornata." },
    "sorry, i don't speak the language very well.": { translation: "Scusi, non parlo molto bene la lingua." },
    "do you speak english?": { translation: "Parla inglese?" },
    "a table for two, please.": { translation: "Un tavolo per due, per favore." },
    "could i see the menu?": { translation: "Posso vedere il menù?" },
    "what do you recommend?": { translation: "Cosa mi consiglia?" },
    "i'll have this one, please.": { translation: "Prendo questo, per favore." },
    "is this spicy?": { translation: "È piccante?" },
    "i'm allergic to nuts.": { translation: "Sono allergico alla frutta secca." },
    "the check, please.": { translation: "Il conto, per favore." },
    "where is the restroom?": { translation: "Dov'è il bagno?" },
    "can i have water, no ice?": { translation: "Posso avere dell'acqua senza ghiaccio?" },
    "delicious, thank you!": { translation: "Delizioso, grazie!" },
    "how much does this cost?": { translation: "Quanto costa?" },
    "do you accept credit card?": { translation: "Accettate la carta di credito?" },
    "is there a discount?": { translation: "C'è uno sconto?" },
    "do you have this in a smaller size?": { translation: "Avete questo in una taglia più piccola?" },
    "can i try it on?": { translation: "Posso provarlo?" },
    "i'll take it.": { translation: "Lo prendo." },
    "just looking, thanks.": { translation: "Sto solo guardando, grazie." },
    "where is the nearest train station?": { translation: "Dov'è la stazione ferroviaria più vicina?" },
    "how do i get to this address?": { translation: "Come arrivo a questo indirizzo?" },
    "is it far from here?": { translation: "È lontano da qui?" },
    "can you show me on the map?": { translation: "Me lo può mostrare sulla mappa?" },
    "which way to the beach?": { translation: "Da che parte è la spiaggia?" },
    "is this the right bus?": { translation: "È questo l'autobus giusto?" },
    "i need help, please.": { translation: "Mi serve aiuto, per favore." },
    "call the police.": { translation: "Chiami la polizia." },
    "i lost my passport.": { translation: "Ho perso il passaporto." },
    "i need a doctor.": { translation: "Ho bisogno di un medico." },
    "where is the pharmacy?": { translation: "Dov'è la farmacia?" },
    "i don't feel well.": { translation: "Non mi sento bene." },
  },
  German: {
    "hello!": { translation: "Hallo!" },
    "thank you so much.": { translation: "Vielen Dank." },
    "goodbye, have a nice day.": { translation: "Auf Wiedersehen, einen schönen Tag noch." },
    "sorry, i don't speak the language very well.": { translation: "Entschuldigung, ich spreche die Sprache nicht sehr gut." },
    "do you speak english?": { translation: "Sprechen Sie Englisch?" },
    "a table for two, please.": { translation: "Einen Tisch für zwei, bitte." },
    "could i see the menu?": { translation: "Könnte ich die Speisekarte sehen?" },
    "what do you recommend?": { translation: "Was empfehlen Sie?" },
    "i'll have this one, please.": { translation: "Ich nehme das, bitte." },
    "is this spicy?": { translation: "Ist das scharf?" },
    "i'm allergic to nuts.": { translation: "Ich bin allergisch gegen Nüsse." },
    "the check, please.": { translation: "Die Rechnung, bitte." },
    "where is the restroom?": { translation: "Wo ist die Toilette?" },
    "can i have water, no ice?": { translation: "Kann ich Wasser ohne Eis bekommen?" },
    "delicious, thank you!": { translation: "Lecker, danke!" },
    "how much does this cost?": { translation: "Wie viel kostet das?" },
    "do you accept credit card?": { translation: "Akzeptieren Sie Kreditkarten?" },
    "is there a discount?": { translation: "Gibt es einen Rabatt?" },
    "do you have this in a smaller size?": { translation: "Haben Sie das in einer kleineren Größe?" },
    "can i try it on?": { translation: "Kann ich es anprobieren?" },
    "i'll take it.": { translation: "Ich nehme es." },
    "just looking, thanks.": { translation: "Ich schaue nur, danke." },
    "where is the nearest train station?": { translation: "Wo ist der nächste Bahnhof?" },
    "how do i get to this address?": { translation: "Wie komme ich zu dieser Adresse?" },
    "is it far from here?": { translation: "Ist es weit von hier?" },
    "can you show me on the map?": { translation: "Können Sie es mir auf der Karte zeigen?" },
    "which way to the beach?": { translation: "Wo geht es zum Strand?" },
    "is this the right bus?": { translation: "Ist das der richtige Bus?" },
    "i need help, please.": { translation: "Ich brauche Hilfe, bitte." },
    "call the police.": { translation: "Rufen Sie die Polizei." },
    "i lost my passport.": { translation: "Ich habe meinen Pass verloren." },
    "i need a doctor.": { translation: "Ich brauche einen Arzt." },
    "where is the pharmacy?": { translation: "Wo ist die Apotheke?" },
    "i don't feel well.": { translation: "Mir geht es nicht gut." },
  },
  Portuguese: {
    "hello!": { translation: "Olá!" },
    "thank you so much.": { translation: "Muito obrigado." },
    "goodbye, have a nice day.": { translation: "Adeus, tenha um bom dia." },
    "sorry, i don't speak the language very well.": { translation: "Desculpe, não falo muito bem o idioma." },
    "do you speak english?": { translation: "Você fala inglês?" },
    "a table for two, please.": { translation: "Uma mesa para dois, por favor." },
    "could i see the menu?": { translation: "Posso ver o cardápio?" },
    "what do you recommend?": { translation: "O que você recomenda?" },
    "i'll have this one, please.": { translation: "Eu quero este, por favor." },
    "is this spicy?": { translation: "Isto é apimentado?" },
    "i'm allergic to nuts.": { translation: "Sou alérgico a nozes." },
    "the check, please.": { translation: "A conta, por favor." },
    "where is the restroom?": { translation: "Onde fica o banheiro?" },
    "can i have water, no ice?": { translation: "Posso ter água, sem gelo?" },
    "delicious, thank you!": { translation: "Delicioso, obrigado!" },
    "how much does this cost?": { translation: "Quanto custa isto?" },
    "do you accept credit card?": { translation: "Aceitam cartão de crédito?" },
    "is there a discount?": { translation: "Tem desconto?" },
    "do you have this in a smaller size?": { translation: "Tem este em um tamanho menor?" },
    "can i try it on?": { translation: "Posso experimentar?" },
    "i'll take it.": { translation: "Vou levar." },
    "just looking, thanks.": { translation: "Só estou olhando, obrigado." },
    "where is the nearest train station?": { translation: "Onde fica a estação de trem mais próxima?" },
    "how do i get to this address?": { translation: "Como chego a este endereço?" },
    "is it far from here?": { translation: "É longe daqui?" },
    "can you show me on the map?": { translation: "Pode me mostrar no mapa?" },
    "which way to the beach?": { translation: "Qual o caminho para a praia?" },
    "is this the right bus?": { translation: "Este é o ônibus certo?" },
    "i need help, please.": { translation: "Preciso de ajuda, por favor." },
    "call the police.": { translation: "Chame a polícia." },
    "i lost my passport.": { translation: "Perdi meu passaporte." },
    "i need a doctor.": { translation: "Preciso de um médico." },
    "where is the pharmacy?": { translation: "Onde fica a farmácia?" },
    "i don't feel well.": { translation: "Não estou me sentindo bem." },
  },
  Japanese: {
    "hello!": { translation: "こんにちは!", romanized: "Konnichiwa!" },
    "thank you so much.": { translation: "どうもありがとうございます。", romanized: "Doumo arigatou gozaimasu." },
    "goodbye, have a nice day.": { translation: "さようなら、良い一日を。", romanized: "Sayounara, yoi ichinichi o." },
    "sorry, i don't speak the language very well.": { translation: "すみません、言語があまり上手ではありません。", romanized: "Sumimasen, gengo ga amari jouzu dewa arimasen." },
    "do you speak english?": { translation: "英語を話せますか?", romanized: "Eigo o hanasemasu ka?" },
    "a table for two, please.": { translation: "二人用のテーブルをお願いします。", romanized: "Futari-you no teeburu o onegaishimasu." },
    "could i see the menu?": { translation: "メニューを見せていただけますか?", romanized: "Menyuu o misete itadakemasu ka?" },
    "what do you recommend?": { translation: "おすすめは何ですか?", romanized: "Osusume wa nan desu ka?" },
    "i'll have this one, please.": { translation: "これをお願いします。", romanized: "Kore o onegaishimasu." },
    "is this spicy?": { translation: "これは辛いですか?", romanized: "Kore wa karai desu ka?" },
    "i'm allergic to nuts.": { translation: "ナッツアレルギーがあります。", romanized: "Nattsu arerugii ga arimasu." },
    "the check, please.": { translation: "お会計お願いします。", romanized: "O-kaikei onegaishimasu." },
    "where is the restroom?": { translation: "トイレはどこですか?", romanized: "Toire wa doko desu ka?" },
    "can i have water, no ice?": { translation: "氷なしでお水をください。", romanized: "Koori nashi de o-mizu o kudasai." },
    "delicious, thank you!": { translation: "美味しかったです、ありがとう!", romanized: "Oishikatta desu, arigatou!" },
    "how much does this cost?": { translation: "これはいくらですか?", romanized: "Kore wa ikura desu ka?" },
    "do you accept credit card?": { translation: "クレジットカードは使えますか?", romanized: "Kurejitto kaado wa tsukaemasu ka?" },
    "is there a discount?": { translation: "割引はありますか?", romanized: "Waribiki wa arimasu ka?" },
    "do you have this in a smaller size?": { translation: "もっと小さいサイズはありますか?", romanized: "Motto chiisai saizu wa arimasu ka?" },
    "can i try it on?": { translation: "試着してもいいですか?", romanized: "Shichaku shitemo ii desu ka?" },
    "i'll take it.": { translation: "これにします。", romanized: "Kore ni shimasu." },
    "just looking, thanks.": { translation: "見ているだけです、ありがとう。", romanized: "Mite iru dake desu, arigatou." },
    "where is the nearest train station?": { translation: "一番近い駅はどこですか?", romanized: "Ichiban chikai eki wa doko desu ka?" },
    "how do i get to this address?": { translation: "この住所までどう行けばいいですか?", romanized: "Kono juusho made dou ikeba ii desu ka?" },
    "is it far from here?": { translation: "ここから遠いですか?", romanized: "Koko kara tooi desu ka?" },
    "can you show me on the map?": { translation: "地図で見せていただけますか?", romanized: "Chizu de misete itadakemasu ka?" },
    "which way to the beach?": { translation: "ビーチへの行き方は?", romanized: "Biichi e no ikikata wa?" },
    "is this the right bus?": { translation: "このバスで合っていますか?", romanized: "Kono basu de atte imasu ka?" },
    "i need help, please.": { translation: "助けてください。", romanized: "Tasukete kudasai." },
    "call the police.": { translation: "警察を呼んでください。", romanized: "Keisatsu o yonde kudasai." },
    "i lost my passport.": { translation: "パスポートをなくしました。", romanized: "Pasupooto o nakushimashita." },
    "i need a doctor.": { translation: "医者が必要です。", romanized: "Isha ga hitsuyou desu." },
    "where is the pharmacy?": { translation: "薬局はどこですか?", romanized: "Yakkyoku wa doko desu ka?" },
    "i don't feel well.": { translation: "気分が悪いです。", romanized: "Kibun ga warui desu." },
  },
  "Mandarin Chinese": {
    "hello!": { translation: "你好!", romanized: "Nǐ hǎo!" },
    "thank you so much.": { translation: "非常感谢。", romanized: "Fēicháng gǎnxiè." },
    "goodbye, have a nice day.": { translation: "再见,祝你有美好的一天。", romanized: "Zàijiàn, zhù nǐ yǒu měihǎo de yītiān." },
    "sorry, i don't speak the language very well.": { translation: "对不起,我说得不太好。", romanized: "Duìbùqǐ, wǒ shuō de bù tài hǎo." },
    "do you speak english?": { translation: "你会说英语吗?", romanized: "Nǐ huì shuō yīngyǔ ma?" },
    "a table for two, please.": { translation: "请给我们两个人的桌子。", romanized: "Qǐng gěi wǒmen liǎng gèrén de zhuōzi." },
    "could i see the menu?": { translation: "我可以看一下菜单吗?", romanized: "Wǒ kěyǐ kàn yīxià càidān ma?" },
    "what do you recommend?": { translation: "你推荐什么?", romanized: "Nǐ tuījiàn shénme?" },
    "i'll have this one, please.": { translation: "请给我这个。", romanized: "Qǐng gěi wǒ zhège." },
    "is this spicy?": { translation: "这个辣吗?", romanized: "Zhège là ma?" },
    "i'm allergic to nuts.": { translation: "我对坚果过敏。", romanized: "Wǒ duì jiānguǒ guòmǐn." },
    "the check, please.": { translation: "请买单。", romanized: "Qǐng mǎidān." },
    "where is the restroom?": { translation: "洗手间在哪里?", romanized: "Xǐshǒujiān zài nǎlǐ?" },
    "can i have water, no ice?": { translation: "请给我一杯水,不要冰。", romanized: "Qǐng gěi wǒ yī bēi shuǐ, bùyào bīng." },
    "delicious, thank you!": { translation: "很好吃,谢谢!", romanized: "Hěn hǎochī, xièxie!" },
    "how much does this cost?": { translation: "这个多少钱?", romanized: "Zhège duōshǎo qián?" },
    "do you accept credit card?": { translation: "你们接受信用卡吗?", romanized: "Nǐmen jiēshòu xìnyòngkǎ ma?" },
    "is there a discount?": { translation: "有折扣吗?", romanized: "Yǒu zhékòu ma?" },
    "do you have this in a smaller size?": { translation: "有小一点的尺寸吗?", romanized: "Yǒu xiǎo yīdiǎn de chǐcùn ma?" },
    "can i try it on?": { translation: "我可以试穿吗?", romanized: "Wǒ kěyǐ shìchuān ma?" },
    "i'll take it.": { translation: "我要这个。", romanized: "Wǒ yào zhège." },
    "just looking, thanks.": { translation: "我只是看看,谢谢。", romanized: "Wǒ zhǐshì kànkan, xièxie." },
    "where is the nearest train station?": { translation: "最近的火车站在哪里?", romanized: "Zuìjìn de huǒchēzhàn zài nǎlǐ?" },
    "how do i get to this address?": { translation: "我怎么去这个地址?", romanized: "Wǒ zěnme qù zhège dìzhǐ?" },
    "is it far from here?": { translation: "离这里远吗?", romanized: "Lí zhèlǐ yuǎn ma?" },
    "can you show me on the map?": { translation: "你能在地图上指给我看吗?", romanized: "Nǐ néng zài dìtú shàng zhǐ gěi wǒ kàn ma?" },
    "which way to the beach?": { translation: "去海滩怎么走?", romanized: "Qù hǎitān zěnme zǒu?" },
    "is this the right bus?": { translation: "这是正确的公交车吗?", romanized: "Zhè shì zhèngquè de gōngjiāochē ma?" },
    "i need help, please.": { translation: "请帮帮我。", romanized: "Qǐng bāng bāng wǒ." },
    "call the police.": { translation: "请叫警察。", romanized: "Qǐng jiào jǐngchá." },
    "i lost my passport.": { translation: "我的护照丢了。", romanized: "Wǒ de hùzhào diūle." },
    "i need a doctor.": { translation: "我需要看医生。", romanized: "Wǒ xūyào kàn yīshēng." },
    "where is the pharmacy?": { translation: "药店在哪里?", romanized: "Yàodiàn zài nǎlǐ?" },
    "i don't feel well.": { translation: "我感觉不舒服。", romanized: "Wǒ gǎnjué bù shūfú." },
  },
};

function norm(s) {
  return (s || "").trim().toLowerCase();
}

/**
 * Look up a built-in offline translation.
 * Returns `{ translation, romanized? }` or null when no static entry exists.
 *
 * `source` is ignored — the bundled phrasebook is always English-sourced.
 */
export function getOfflineTranslation(text, _source, target) {
  const lang = OFFLINE[target];
  if (!lang) return null;
  return lang[norm(text)] || null;
}

export function hasOfflineSupport(target) {
  return Boolean(OFFLINE[target]);
}
